import Vue from 'vue'
import { ipcRenderer as ipc, Event } from 'electron'
import { Store } from 'vuex'
import { UI_SET_SEARCH_FOCUS, UI_SET_LAST_URL } from '@/store/ui/constants'
import { RootState } from '@/store/types'
import PStorage, { PRIVATE_KEY, API_TOKEN } from '@/util/PStorage'
import Locker from '@/util/Locker'
import { VAULT_TREE_CLOSE_ALL } from '@/store/entries/constants'
import { EDITOR_CLEAR, EDITOR_SET_SCHEMA, RESET_EDITOR } from '@/store/editor/constants'

export default (vue: Vue) => {
    const { state, getters, commit, dispatch }: Store<RootState> = vue.$store;
    (window as any).vue = vue
    ipc.on('global-shortcut', () => {
        commit(UI_SET_SEARCH_FOCUS, false)
        vue.$nextTick(() => {
            commit(UI_SET_SEARCH_FOCUS, true)
        })
    })
    ipc.on('new-entry', () => {
        commit(EDITOR_CLEAR)
        commit(EDITOR_SET_SCHEMA, 'website')
    })
    ipc.on('lock', () => {
        PStorage.remove(PRIVATE_KEY)
        PStorage.remove(API_TOKEN)
        Locker.lock()
    })
    ipc.on('close-entry', () => {
        dispatch(RESET_EDITOR)
    })
    ipc.on('close-vaults', () => {
        commit(VAULT_TREE_CLOSE_ALL)
    })
    ipc.on('preferences', () => {
        if (vue.$route.path.startsWith('/preferences')) {
            vue.$router.push(state.ui.lastUrl || '/')
        } else {
            commit(UI_SET_LAST_URL, vue.$route.path)
            vue.$router.push('/preferences')
        }
    })

    /**
     * Handle PStorage requests
     */
    ipc.on('get-storage', (event: Event, key: string, touch?: boolean) => {
        ipc.send(`storage-${key}`, PStorage.get(key, touch))
    })
}
